import getConfig from 'next/config';

const config = getConfig()?.publicRuntimeConfig;

export const IMAGE_PREFIX: string = config?.IMAGE_PREFIX || 'https://imgproxy.life.church';

export const DEFAULT_LOCALE = 'en-US';
export const ALLOWED_APPEREANCE_FIELDS = {
  appearance: 'Appearance',
  login_banner: 'Login Banner',
  share_description: 'Share Description',
  share_image: 'Sharing Image',
  offline_prayer_recipients: 'Offline Prayer Recipients',
  logo: 'Logo',
  dark_logo: 'Dark Logo',
  favicon: 'Favicon',
  visual_mode: 'Default Visual Mode',
  enable_dark_mode: 'Enable Dark Mode',
  header_text_color: 'Header Text Color',
  header_background_color: 'Header Background Color',
  navigation_link_case: 'Navigation Link Case',
  hide_viewership_metric: 'Hide Viewership Metric',
  body_text: 'Login Banner Text',
  enabled: 'Login Banner',
  custom_domain: 'Custom Domain',
  email_consent: 'Email Consent',
  privacy_url: 'Privacy URL',
  terms_url: 'Terms URL',
  name: 'Church Name',
  website: 'Church Website',
  address: 'Church Address',
  timezone: 'Timezone',
  city: 'City',
  country: 'Country',
  state: 'State',
  zip: 'Zip Code',
};
export const ALLOWED_CONTENT_FIELDS = {
  title: 'Title',
  duration: 'Duration',
  notes: 'Notes',
  host_info: 'Host Info',
  chat_start_offset: 'Chat Start Offset',
  chat_end_offset: 'Chat End Offset',
  video_start_offset: 'Video Start Offset',
  features: 'Features',
  has_video: 'Has Video',
  live_prayer: 'Live Prayer',
  public_chat: 'Public Chat',
};
export const ALLOWED_SERVICE_TIMES_FIELDS = {
  first_time: 'Start Date/Time',
  day_of_week: 'Day of Week',
  week_of_month: 'Week of Month',
  day_of_month: 'Day of Month',
  month_of_year: 'Month',
  recurrence_type_id: 'Recurrence',
};
